import { Link } from 'react-router-dom';
import * as style from '../utils/general_style';
import * as links from '../utils/general_links';
import image from '../assets/plan-du-site.png';

function PlanSite() {

    const sitePages = [
        {
            label: 'Accueil',
            link: links.ROUTES.home
        },{
            label: 'Présentation des études de sol',
            link: links.ROUTES.presentation
        },{
            label: `Loi Elan: qu'est-ce que c'est ?`,
            link: links.ROUTES.loiElan
        },{
            label: 'Qui sommes-nous ?',
            link: links.ROUTES.quiSommesNous
        },{
            label: 'Foire Aux Questions',
            link: links.ROUTES.faq
        }
    ];

    const actionPages = [
        {
            label: `Réalisation d'un devis`,
            link: links.ROUTES.devis
        },{
            label: 'Demande de contact',
            link: links.ROUTES.contact
        },{
            label: 'Accès espace pro',
            link: links.ROUTES.espacePro
        }
    ];

    const legalPages = [
        {
            label: 'Mentions Légales',
            link: links.ROUTES.mentionsLegales
        },{
            label: 'Politique relative aux cookies',
            link: links.ROUTES.politiqueCookies
        },{
            label: 'Politique de protection des données personnelles',
            link: links.ROUTES.politiqueProtection
        }
    ];

    const lists = [{ title: 'Pages du site', array: sitePages }, {title: 'Formulaires', array: actionPages}, { title: 'Pages légales', array: legalPages }];
    const iconStyle = {position: 'relative', top: '3px', marginRight: style.SPACE.extraSmall, color: style.COLORS.primary};

	return (
        <div className='AppBody noCTABar'>
            <section style={style.ELEMENT_BLOCK_GREY}>
                <div style={{...style.COLUMN_CENTER, width: '100%', marginBottom: style.SPACE.extraLarge}}>
                    <h1 style={{...style.TITLE, backgroundColor: style.COLORS.white}}>Plan du Site</h1>
                </div>
                <div style={{width: '50%', margin: 'auto'}}>
                    <img src={ image } alt={'représentation de plusieurs pages du site'} />
                </div>
                <article style={{...style.ROW_SPACE_AROUND, alignItems: 'start', padding: `${style.SPACE.extraLarge} 0px`, height: '350px'}}>
                    {lists.map(({title, array}, index) => (
                        <div style={{width: '100%', border: `1px solid ${style.COLORS.grey}`, borderRadius: '20px', padding: style.SPACE.extraLarge, height: '100%', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.15)', margin: `0px ${style.SPACE.extraSmall}`, backgroundColor: style.COLORS.white}} key={ index }>
                            <h2 style={{textAlign: 'left'}}>{ title }</h2>
                            <ul style={{marginTop: style.SPACE.medium}}>
                                {array.map(({label, link}, new_index) => (
                                    <li style={{margin: style.SPACE.medium, marginLeft: style.SPACE.extraSmall}} key={ new_index }>
                                        <Link to={ link } style={{justifyContent: 'start'}}>
                                            <i className="fa-solid fa-arrow-pointer fa-flip-horizontal fa-xs" style={iconStyle}></i>{ label }
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </article>
            </section>
        </div>
	);
};

export default PlanSite;